import { useAuth } from "@/contexts/AuthContext";

export interface TenantMember {
  id: string;
  tenant_id: string;
  user_id: string;
  role: "owner" | "master" | "professor";
  status: "active" | "invited" | "disabled";
}

export function useTenant() {
  const { user, role, tenantId, isPlatformOwner, loading } = useAuth();

  return {
    membership: user && tenantId ? { tenant_id: tenantId, user_id: user.id, role: role as TenantMember["role"] } : null,
    tenantId,
    role: isPlatformOwner ? ("owner" as const) : role,
    isPlatformOwner,
    loading,
  };
}
